import React from 'react';
import { connect } from 'react-redux';
import {
  Button, Card, CardBody, CardTitle,
} from 'reactstrap';
import { Form, actions } from 'react-redux-form/immutable';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import qs from 'qs';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { LabeledText } from '../../../../../form/LabeledText';
import { LabeledSelect } from '../../../../../form/LabeledSelect';
import { tsunamiEventSearchModel, toSearchParameters } from './tsunamiEventSearchModel';
import {
  searchTsunamiEvents as searchTsunamiEventsAc,
  clearTsunamiEventSearch as clearTsunamiEventSearchAc,
  getRegions as getRegionsAc,
  getCountries as getCountriesAc,
  getAreas as getAreasAc,
  getRunupAreas as getRunupAreasAc,
  getRunupRegions as getRunupRegionsAc,
  getRunupCountries as getRunupCountriesAc,
  getRunupMeasurementTypes as getRunupMeasurementTypesAc,
  getValidity as getValidityAc,
  getCauses as getCausesAc,
} from '../../../../../../redux/tsunamis/event/search/tsunamiEventSearchActions';
import { Loading } from '../../../../../loadbar/Loading';
import { withUser } from '../../../../../auth/withUser';
import { isDataManager } from '../../../../../../role/roleUtils';
import { MinMaxSearchCard } from '../../../../../form/search/MinMaxSearchCard';
import { LatLongSearchCard } from '../../../../../form/search/LatLongSearchCard';
import { MinMaxSelectSearchCard } from '../../../../../form/search/MinMaxSelectSearchCard';
import { TextMatchSearchCard } from '../../../../../form/search/TextMatchSearchCard';
import { EffectsSearchCard } from '../../../../../form/search/EffectsSearchCard';
// import { About } from '../../../../about/About';

const model = tsunamiEventSearchModel.get('name');

class TsunamiSearchPageUnwrapped extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    document.title = 'NCEI Hazard Tsunami Search';
    const {
      clearTsunamiEventSearch, getRegions, getCountries, getRunupRegions, getRunupCountries, getRunupMeasurementTypes, getValidity, getCauses, history,
      selectedCountry, getAreas, selectedRunupCountry, getRunupAreas,
    } = this.props;
    clearTsunamiEventSearch();
    getRegions({ history });
    getCountries({ history });
    getRunupRegions({ history });
    getRunupCountries({ history });
    getRunupMeasurementTypes({ history });
    getValidity({ history });
    getCauses({ history });
    if (selectedCountry) {
      getAreas({ country: selectedCountry, history });
    }
    if (selectedRunupCountry) {
      getRunupAreas({ country: selectedRunupCountry, history });
    }
  }

  componentDidUpdate(prevProps) {
    const {
      selectedCountry,
      change,
      selectedArea,
      selectedRunupCountry,
      selectedRunupArea,
      getAreas,
      getRunupAreas,
      history,
    } = this.props;
    const { selectedCountry: prevSelectedCountry, selectedRunupCountry: prevSelectedRunupCountry } = prevProps;
    const prevSelectedRunupCountrySplit = prevSelectedRunupCountry.split(';').map(s => s.trim());
    const selectedRunupCountrySplit = selectedRunupCountry.split(';').map(s => s.trim());

    if (prevSelectedCountry !== selectedCountry) {
      if (selectedArea) {
        change('.area', '');
      }
      if (selectedCountry) {
        getAreas({ country: selectedCountry, history });
      }
    }

    if (prevSelectedRunupCountrySplit[0] !== selectedRunupCountrySplit[0]) {
      if (selectedRunupArea) {
        change('.runupArea', '');
      }
      if (selectedRunupCountrySplit[0]) {
        getRunupAreas({ country: selectedRunupCountrySplit[0], history });
      }
    }
  }

  handleSubmit(form) {
    const { searchTsunamiEvents, history, authorities } = this.props;
    const queryParameters = toSearchParameters(form, isDataManager(authorities));
    const location = {
      pathname: '/view/hazards/tsunami/event-data',
      search: qs.stringify(toSearchParameters(form, isDataManager(authorities)), { skipNulls: true }),
    };
    searchTsunamiEvents({
      queryParameters, formModel: model, location, searchRedirect: true, history,
    });
  }

  render() {
    const {
      resetForm,
      searching,
      fetched,
      regions,
      countries,
      areas,
      fetchingAreas,
      runupAreas,
      runupRegions,
      runupCountries,
      fetchingRunupAreas,
      runupMeasurementTypes,
      peopleDescriptors,
      damageDescriptors,
      housesDescriptors,
      validities,
      causes,
      authorities,
    } = this.props;

    if (!fetched || searching) {
      return (<Loading />);
    }

    const peopleDescriptorsJs = peopleDescriptors.toJS();
    const damageDescriptorsJs = damageDescriptors.toJS();
    const housesDescriptorsJs = housesDescriptors.toJS();
    const validitiesJs = validities.toJS();
    // eslint-disable-next-line no-nested-ternary
    const causesJs = causes.toJS().sort((a, b) => ((parseInt(a.id, 10) > parseInt(b.id, 10)) ? 1 : ((parseInt(b.id, 10) > parseInt(a.id, 10)) ? -1 : 0)));
    const causesJs2 = causes.toJS().map(x => ({ id: x.id, description: `${(`00${x.id}`).slice(-2)} - ${x.description}` }));
    // eslint-disable-next-line no-unused-vars
    const regionsJs = regions.toJS().map(x => ({ id: x.id, description: `${(`00${x.id}`).slice(-2)} - ${x.description}` }));
    const runupRegionsJs = runupRegions.toJS().map(x => ({ id: x.id, description: `${(`00${x.id}`).slice(-2)} - ${x.description}` }));
    const oceanicTsunamiJs = [{ id: 'true', description: 'Yes = Oceanic tsunami indicates the tsunami originated in an ocean body.' }, { id: 'false', description: 'No = disturbance or tsunami waves originated in an inland river/lake.' }];

    const dataManager = isDataManager(authorities);

    return (
      <div className="haz-results-container haz-page-container">
        <Card className="haz-page-card">
          <CardBody>
            <CardTitle tag="h1" className="haz-page-card-title">Search Tsunami Events</CardTitle>
            <p>
              The NCEI/WDS Global Historical Tsunami Database contains tsunami source information. The tsunami source data is related to tsunami runup data which contains information on locations where tsunami effects were observed. Please see the
              {' '}
              <a href={window.externalTsuIntroLink} target="_blank" rel="noopener noreferrer">tsunami introduction</a>
              {' '}
              for more information on the NOAA/WDS tsunami database as well as our
              {' '}
              <a href={window.externalMapViewerLink} target="_blank" rel="noopener noreferrer">map viewer</a>
              .
            </p>
            {/* https://www.ngdc.noaa.gov/hazard/tsunami-db-intro.html */}
            {/* https://maps.ngdc.noaa.gov/viewers/hazards/?layers=0 */}
            <p>
              Please cite as:
              <br />
              {' '}
              <b>
                National Geophysical Data Center / World Data Service: NCEI/WDS Global Historical Tsunami Database. NOAA National Centers for Environmental Information.
                {' '}
                <a href="http://dx.doi.org/10.7289/V5PN93H7" rel="noopener noreferrer" target="_blank" title="Tsunami Event DOI Information" aria-label="Tsunami Event DOI Information">doi:10.7289/V5PN93H7</a>
              </b>
            </p>

            <Form model={model} onSubmit={this.handleSubmit} noValidate>

              <div>
                <Button color="primary" type="submit" className="ml-5">Search</Button>
                <Button color="secondary" className="ml-3" onClick={resetForm}>Clear</Button>
              </div>
              <br />

              { dataManager && (
              <Card>
                <CardBody>
                  <CardTitle tag="h2">Tsunami ID</CardTitle>
                  <LabeledText model=".id" label="ID" />
                  <MinMaxSearchCard min=".minId" max=".maxId">ID Range</MinMaxSearchCard>
                </CardBody>
              </Card>
              )}

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Tsunami Source Parameters</CardTitle>
                  { dataManager && (
                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-sm-6']} model=".month" label="Month" />
                    <LabeledText formGroupClassName={['col-sm-6']} model=".day" label="Day" />
                  </div>
                  )}
                  <MinMaxSearchCard min=".minYear" max=".maxYear" helpModalId="year">Year</MinMaxSearchCard>

                  <div className="form-row">
                    <LabeledSelect childOptions={regionsJs} formGroupClassName={['col-lg-6']} parentModel={model} fieldId="regionCode" label="Region" multiselect filterable helpModalId="tsuRegion" />
                    <LabeledSelect childOptions={countries.toJS()} formGroupClassName={['col-lg-4']} parentModel={model} fieldId="country" label="Country" filterable readOnly={fetchingAreas} helpModalId="tsuCountry" />
                    <LabeledSelect childOptions={areas.toJS()} formGroupClassName={['col-lg-2']} parentModel={model} fieldId="area" label="Area" readOnly={fetchingAreas || !areas.size} filterable helpModalId="tsuArea" />
                  </div>

                  <TextMatchSearchCard
                    radioGroupModel=".radios.locationSearchType"
                    textModel=".radios.loc"
                    startsWith="locStart"
                    includes="locInclude"
                    matches="locMatch"
                    doesNotMatch="locNot"
                    helpModalId="tsuLocationName"
                  >
                    Location
                  </TextMatchSearchCard>
                  <LatLongSearchCard helpModalIdPrefix="tsu" model={model} />

                  <MinMaxSelectSearchCard
                    model={model}
                    minField="minEventValidity"
                    maxField="maxEventValidity"
                    descriptors={validitiesJs}
                    prependId
                    helpModalId="tsuValidity"
                  >
                    Validity
                  </MinMaxSelectSearchCard>

                  {isDataManager(authorities) && (
                  <MinMaxSelectSearchCard
                    model={model}
                    minField="minCauseCode"
                    maxField="maxCauseCode"
                    descriptors={causesJs}
                    prependId
                    helpModalId="tsuCauseCode"
                  >
                    Cause of Tsunami
                  </MinMaxSelectSearchCard>
                  )}

                  <Card>
                    <CardBody>
                      <div className="form-row">
                        <LabeledSelect childOptions={causesJs2} formGroupClassName={['col-6']} parentModel={model} fieldId="causeCode" label="Cause of Tsunami" multiselect filterable helpModalId="tsuCauseCode" />
                        <LabeledSelect childOptions={oceanicTsunamiJs} formGroupClassName={['col-6']} parentModel={model} fieldId="oceanicTsunami" label="Oceanic Tsunami" sorted={false} helpModalId="tsuOceanicTsunami" />
                      </div>
                    </CardBody>
                  </Card>


                  <MinMaxSearchCard min=".minEqMagnitude" max=".maxEqMagnitude" helpModalId="eqMagnitude">Earthquake Magnitude</MinMaxSearchCard>

                  <TextMatchSearchCard
                    radioGroupModel=".radios.commentsSearchType"
                    textModel=".radios.comments"
                    startsWith="commentsStart"
                    includes="commentsInclude"
                    matches="commentsMatch"
                    doesNotMatch="commentsNot"
                    helpModalId="tsuComments"
                  >
                    Comments
                  </TextMatchSearchCard>

                  <MinMaxSearchCard min=".minMaxWaterHeight" max=".maxMaxWaterHeight" helpModalId="tsuMaxWaterHeight">Maximum Water Height (m)</MinMaxSearchCard>
                </CardBody>
              </Card>

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Runup Parameters</CardTitle>
                  <MinMaxSearchCard min=".minNumRunups" max=".maxNumRunups" helpModalId="tsuRunups">Number of Runups</MinMaxSearchCard>
                  <div className="form-row">
                    <LabeledSelect
                      formGroupClassName={['col-lg-6']}
                      parentModel={model}
                      fieldId="runupMeasureType"
                      label="Type of Measurement"
                      sorted={false}
                      prependId
                      multiselect={dataManager}
                      helpModalId="ruMeasurementType"
                      childOptions={runupMeasurementTypes.toJS()}
                    />
                    <LabeledSelect
                      formGroupClassName={['col-lg-6']}
                      parentModel={model}
                      fieldId="runupDoubtful"
                      label="Validity of Runup"
                      sorted={false}
                      unselectedText="Select Doubtfulness"
                      helpModalId="ruDoubtful"
                      multiselect={dataManager}
                      childOptions={[
                        { id: 'n', description: 'OK' },
                        { id: 'y', description: 'Doubtful' },
                        { id: 'm', description: 'Meteorological' },
                        { id: 'a', description: 'Atmospheric' },
                      ]}
                    />
                  </div>
                  <div className="form-row row-margin-fix">
                    <MinMaxSearchCard className="col-md-4" min=".runupMinHeight" max=".runupMaxHeight" helpModalId="ruHeight">Vertical Height at Runup Location (m)</MinMaxSearchCard>
                    <MinMaxSearchCard className="col-md-4" min=".cforunupMinTroughHt" max=".runupMaxTroughHt" helpModalId="ruTroughHt">Maximum Trough Height at Runup Location (m)</MinMaxSearchCard>
                    <MinMaxSearchCard className="col-md-4" min=".minRunupHoriz" max=".maxRunupHoriz" helpModalId="ruInundation">Maximum Inundation Distance (m)</MinMaxSearchCard>
                  </div>
                </CardBody>
              </Card>

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Tsunami Runup By Place</CardTitle>

                  <div className="form-row">
                    <LabeledSelect childOptions={runupRegionsJs} formGroupClassName={['col-lg-6']} parentModel={model} fieldId="runupRegion" label="Region" multiselect filterable />
                    <LabeledSelect childOptions={runupCountries.toJS()} formGroupClassName={['col-lg-4']} parentModel={model} fieldId="runupCountry" label="Country" readOnly={fetchingRunupAreas} multiselect filterable helpModalId="ruCountry" splitString=";" />
                    <LabeledSelect childOptions={runupAreas.toJS()} formGroupClassName={['col-lg-2']} parentModel={model} fieldId="runupArea" label="Area" readOnly={fetchingRunupAreas || !runupAreas.size} filterable helpModalId="ruArea" />
                  </div>

                  <div className="form-row row-margin-fix">
                    <MinMaxSearchCard className="col-md-6" min=".runupMinDistance" max=".runupMaxDistance" helpModalId="ruDistance">Distance of Runup Location (km)</MinMaxSearchCard>
                    <MinMaxSearchCard className="col-md-6" min=".runupMinTravelTime" max=".runupMaxTravelTime" helpModalId="ruWaveTravelHour">Travel Time (hours)</MinMaxSearchCard>
                  </div>

                  <TextMatchSearchCard
                    radioGroupModel=".radios.runupLocationSearchType"
                    textModel=".radios.runupLoc"
                    startsWith="runupLocStart"
                    includes="runupLocInclude"
                    matches="runupLocMatch"
                    doesNotMatch="runupLocNot"
                    helpModalId="ruLocation"
                  >
                    Runup Location
                  </TextMatchSearchCard>

                </CardBody>
              </Card>


              <EffectsSearchCard
                helpModalIdPrefix="tsu"
                deaths
                damage
                injuries
                housedDestroyed
                model={model}
                peopleDescriptors={peopleDescriptorsJs}
                damageDescriptors={damageDescriptorsJs}
                housesDescriptors={housesDescriptorsJs}
              >
                Tsunami Effects
              </EffectsSearchCard>

              <EffectsSearchCard
                helpModalIdPrefix="tsu"
                total
                deaths
                damage
                model={model}
                peopleDescriptors={peopleDescriptorsJs}
                damageDescriptors={damageDescriptorsJs}
              >
                Total Tsunami and Source Effects
              </EffectsSearchCard>

              <EffectsSearchCard
                helpModalIdPrefix="ru"
                deaths
                damage
                injuries
                housedDestroyed
                model={model}
                peopleDescriptors={peopleDescriptorsJs}
                damageDescriptors={damageDescriptorsJs}
                housesDescriptors={housesDescriptorsJs}
                minDeathsField=".runupMinDeaths"
                maxDeathsField=".runupMaxDeaths"
                minDeathsDescField="runupMinDeathsAmountOrder"
                maxDeathsDescField="runupMaxDeathsAmountOrder"
                minInjuriesField=".runupMinInjuries"
                maxInjuriesField=".runupMaxInjuries"
                minInjuriesDescField="runupMinInjuriesAmountOrder"
                maxInjuriesDescField="runupMaxInjuriesAmountOrder"
                minDamageField=".runupMinDamageMillionsDollars"
                maxDamageField=".runupMaxDamageMillionsDollars"
                minDamageDescField="runupMinDamageAmountOrder"
                maxDamageDescField="runupMaxDamageAmountOrder"
                minHousesDestroyedField=".runupMinHousesDestroyed"
                maxHousesDestroyedField=".runupMaxHousesDestroyed"
                minHousesDestroyedDescField="runupMinHousesDestroyedAmountOrder"
                maxHousesDestroyedDescField="runupMaxHousesDestroyedAmountOrder"
              >
                Effects at Runup Location
              </EffectsSearchCard>

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Event Has Associated Deposits</CardTitle>
                  <div className="form-row">
                    <LabeledSelect
                      formGroupClassName={['col-md-12']}
                      parentModel={model}
                      fieldId="assocDeposits"
                      label="Associated Deposits"
                      unselectedText="None Selected"
                      childOptions={[
                        { id: 'no', description: 'Deposits Were Not Associated' },
                        { id: 'yes', description: 'Deposits Were Associated' },
                      ]}
                    />
                  </div>
                </CardBody>
              </Card>

              <br />
              <div>
                <Button color="primary" type="submit" aria-label="Search Option 2" className="ml-5">Search</Button>
                <Button color="secondary" className="ml-3" aria-label="Clear Option 2" onClick={resetForm}>Clear</Button>
              </div>

            </Form>
          </CardBody>
        </Card>
      </div>
    );
  }
}

TsunamiSearchPageUnwrapped.propTypes = {
  searchTsunamiEvents: PropTypes.func.isRequired,
  clearTsunamiEventSearch: PropTypes.func.isRequired,
  resetForm: PropTypes.func.isRequired,
  // resetField: PropTypes.func.isRequired,
  searching: PropTypes.bool.isRequired,
  selectedCountry: PropTypes.string.isRequired,
  selectedArea: PropTypes.string.isRequired,
  selectedRunupCountry: PropTypes.string.isRequired,
  selectedRunupArea: PropTypes.string.isRequired,
  change: PropTypes.func.isRequired,
  getRegions: PropTypes.func.isRequired,
  getCountries: PropTypes.func.isRequired,
  getAreas: PropTypes.func.isRequired,
  getRunupRegions: PropTypes.func.isRequired,
  getRunupCountries: PropTypes.func.isRequired,
  getRunupAreas: PropTypes.func.isRequired,
  getRunupMeasurementTypes: PropTypes.func.isRequired,
  getValidity: PropTypes.func.isRequired,
  getCauses: PropTypes.func.isRequired,

  regions: ImmutablePropTypes.list.isRequired,
  countries: ImmutablePropTypes.list.isRequired,
  areas: ImmutablePropTypes.list.isRequired,
  runupRegions: ImmutablePropTypes.list.isRequired,
  runupCountries: ImmutablePropTypes.list.isRequired,
  runupAreas: ImmutablePropTypes.list.isRequired,
  runupMeasurementTypes: ImmutablePropTypes.list.isRequired,
  peopleDescriptors: ImmutablePropTypes.list.isRequired,
  damageDescriptors: ImmutablePropTypes.list.isRequired,
  housesDescriptors: ImmutablePropTypes.list.isRequired,
  validities: ImmutablePropTypes.list.isRequired,
  causes: ImmutablePropTypes.list.isRequired,

  fetched: PropTypes.bool.isRequired,
  fetchingAreas: PropTypes.bool.isRequired,
  fetchingRunupAreas: PropTypes.bool.isRequired,

  history: PropTypes.shape({}).isRequired,
  authorities: ImmutablePropTypes.list.isRequired,
};


const mapStateToProps = state => ({
  searching: state.getIn(['tsunamiEventSearchPage', 'searching']),
  selectedCountry: state.getIn([model, 'country']),
  selectedArea: state.getIn([model, 'area']),
  selectedRunupCountry: state.getIn([model, 'runupCountry']),
  selectedRunupArea: state.getIn([model, 'runupArea']),
  fetched: [
    state.getIn(['tsunamiEventSearchPage', 'fetchedRegions']),
    state.getIn(['tsunamiEventSearchPage', 'fetchedCountries']),
    state.getIn(['tsunamiEventSearchPage', 'fetchedRunupRegions']),
    state.getIn(['tsunamiEventSearchPage', 'fetchedRunupCountries']),
    state.getIn(['tsunamiEventSearchPage', 'fetchedRunupMeasurementTypes']),
    state.getIn(['tsunamiEventSearchPage', 'fetchedValidities']),
    state.getIn(['tsunamiEventSearchPage', 'fetchedCauses']),
  ].every(v => v),
  fetchingAreas: state.getIn(['tsunamiEventSearchPage', 'fetchingAreas']),
  regions: state.getIn(['tsunamiEventSearchPage', 'regions']),
  countries: state.getIn(['tsunamiEventSearchPage', 'countries']),
  areas: state.getIn(['tsunamiEventSearchPage', 'areas']),
  runupRegions: state.getIn(['tsunamiEventSearchPage', 'runupRegions']),
  runupCountries: state.getIn(['tsunamiEventSearchPage', 'runupCountries']),
  runupAreas: state.getIn(['tsunamiEventSearchPage', 'runupAreas']),
  fetchingRunupAreas: state.getIn(['tsunamiEventSearchPage', 'fetchingRunupAreas']),
  runupMeasurementTypes: state.getIn(['tsunamiEventSearchPage', 'runupMeasurementTypes']),
  damageDescriptors: state.getIn(['effectDescriptors', 'damage']),
  peopleDescriptors: state.getIn(['effectDescriptors', 'people']),
  housesDescriptors: state.getIn(['effectDescriptors', 'houses']),
  validities: state.getIn(['tsunamiEventSearchPage', 'validities']),
  causes: state.getIn(['tsunamiEventSearchPage', 'causes']),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  searchTsunamiEvents: searchTsunamiEventsAc,
  clearTsunamiEventSearch: clearTsunamiEventSearchAc,
  /* resetForm: () => actions.setInitial(model), */
  resetForm: () => actions.reset(model),
  resetField: field => actions.setInitial(`model.${field}`),
  change: (field, value) => actions.change(`${model}${field}`, value),
  // clearEarthquakeSearch: clearEarthquakeSearchAc,
  getRegions: getRegionsAc,
  getCountries: getCountriesAc,
  getAreas: getAreasAc,
  getRunupRegions: getRunupRegionsAc,
  getRunupCountries: getRunupCountriesAc,
  getRunupAreas: getRunupAreasAc,
  getRunupMeasurementTypes: getRunupMeasurementTypesAc,
  getValidity: getValidityAc,
  getCauses: getCausesAc,
}, dispatch);

export const TsunamiSearchPage = withUser(connect(mapStateToProps, mapDispatchToProps)(TsunamiSearchPageUnwrapped));
